import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
    },
    info: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    infoCell: {
      minWidth: '50%',
      width: '50%',
      color: colorsPalette.gray,
      fontSize: 18,
      lineHeight: 1.5,
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.down('md')]: {
        minWidth: '100%',
        width: '100%',
      },
    },
    infoCellPlaceholder: {
      minWidth: '50%',
      width: '50%',
    },
    infoLabel: {
      fontSize: 18,
      fontWeight: 700,
      lineHeight: 1.2,
      color: colorsPalette.white,
      marginBottom: SMALL_MARGIN,
    },
    interestItem: {
      '&:not(:first-of-type):before': {
        content: '", "',
        display: 'inline',
      },
    },
    btn: {
      minWidth: 150,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  }),
);

export default useStyles;
